import { createHttpAction } from '@securitize/ui-components';
import { QUALIFICATION_QUESTIONS_NEXT, SUBMIT_QUALIFICATION_QUESTIONS_NEXT } from './actionTypes';

export const getQualificationQuestions = (opportunityId) => createHttpAction(QUALIFICATION_QUESTIONS_NEXT, {
  query: { opportunityId },
}).action;

export const submitQualificationQuestions = (payload, opportunityId, onFinish) => createHttpAction(
  SUBMIT_QUALIFICATION_QUESTIONS_NEXT, { body: payload, query: { opportunityId } }, { onFinish },
).action;
